import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { runRtkQuery } from '../helperFn';

export const fileApi = createApi({
  reducerPath: 'fileApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    generateCsvFile: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'generateFile');
      },
    }),
  }),
});

export const { useGenerateCsvFileMutation } = fileApi;
